import type { SVGProps } from 'react';

const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.17818 2.7451C9.54588 2.00504 10.6016 2.00504 10.9693 2.7451L12.5896 6.00619C12.7352 6.29926 13.015 6.50253 13.3387 6.55046L16.9409 7.08371C17.7583 7.20472 18.0846 8.20875 17.4944 8.78715L14.8936 11.3359C14.6598 11.5649 14.553 11.8938 14.6074 12.2165L15.2134 15.8072C15.3509 16.622 14.4968 17.2425 13.7644 16.86L10.5367 15.1741C10.2466 15.0225 9.90081 15.0225 9.61075 15.1741L6.38309 16.86C5.65062 17.2425 4.79654 16.622 4.93405 15.8072L5.54004 12.2165C5.5945 11.8938 5.48763 11.5649 5.2539 11.3359L2.65311 8.78715C2.0629 8.20875 2.38913 7.20472 3.20659 7.08371L6.80878 6.55046C7.13249 6.50253 7.41228 6.29926 7.55789 6.00619L9.17818 2.7451Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgStar;
